export default "__VITE_ASSET__C4JLM6De__"